import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { ADMISION } from './Styles/StylesAdmision';


class ReciboDePagoUrl extends Component {
    state = {  }
    ajustar = (tam, num) => {
        if (num.toString().length <= tam) return this.ajustar(tam, "0" + num)
        return num;
    }

    qrC = (qr, styles) => {
        if (qr === "") return null;

        return (<Image
            style={[styles.logoQr, {left:20}]}
            src={qr}
        />)
    }

    contenido = (tipo) => {
        const styles = StyleSheet.create(ADMISION[0]);
        let { datos, qrCode, logo } = this.props;

        let items = (dato) => (
            dato.map(option => (
                <View key={option[0]} style={[styles.row]}>
                    <Text style={[styles.colTablaRec1, styles.font8, styles.bordeCol11, styles.center]}>{option.id}</Text>
                    <Text style={[styles.colTablaRec2, styles.font8, styles.bordeCol9, styles.center]}>{option.fecha}</Text>
                    <Text style={[styles.colTablaRec3, styles.font8, styles.bordeCol9]}>{option.item}</Text>
                    <Text style={[styles.colTablaRec4, styles.font8, styles.bordeCol9, styles.center]}>{option.haber} Bs.</Text>
                </View>
            ))
        )
        
        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                    <Text style={[styles.token]}>N° - {this.ajustar(9, datos.id)}</Text>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    RECIBO DE PAGO
                </Text>
                
                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DETALLES DEL ESTUDIANTE</Text>
                    <View style={[{padding: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.col2, styles.font9]}>Cédula de Identidad: {datos.ci}</Text>
                            <Text style={[styles.col4, styles.font9, {textAlign: "right"}]}>Nombres y Apellidos: {datos.estudiante}</Text>
                        </View>
                    </View>
                </View>

                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4, marginTop: 5}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. DETALLES DE LA TRANSACCIÓN</Text>

                    <View style={[styles.row, {marginTop: 5}]}>
                        <Text style={[styles.colTablaRec1, styles.font9, styles.bordeCol11, styles.borderTop,  styles.center, {backgroundColor: "#888", color:"#FFF"}]}>Num.</Text>
                        <Text style={[styles.colTablaRec2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#888", color:"#FFF"}]}>Fecha</Text>
                        <Text style={[styles.colTablaRec3, styles.font9, styles.bordeCol9, styles.borderTop, {backgroundColor: "#888", color:"#FFF"}]}>Descripción</Text>
                        <Text style={[styles.colTablaRec4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#888", color:"#FFF"}]}>Monto</Text>
                    </View>
                    {items(datos.transacciones)}
                    <View style={[styles.row]}>
                        <Text style={[styles.colTablaRec5, styles.font9, {paddingTop: 4, paddingRight: 5, paddingLeft: 5, borderBottom: 0.5, borderLeft: 0.5}]}>MÉTODO DE PAGO: <Text style={{color:"#c60000"}}>{datos.metodo}</Text></Text>
                        <Text style={[styles.colTablaRec6, styles.font9, {color:"#c60000", textAlign: "right", paddingTop: 4, paddingRight: 5, borderBottom: 0.5}]}>TOTAL PAGADO</Text>
                        <Text style={[styles.colTablaRec4, styles.font10, styles.bordeCol9, styles.center]}>{datos.total} Bs.</Text>
                    </View>
                </View>

                <View style={styles.row}>
                    <Text style={[styles.tipo, {textAlign: "right", marginTop: 10}]}>{tipo}</Text>
                </View>

                <View style={[styles.footer3, {marginTop: 10}]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col9]}>
                            <Text style={[styles.encabezado, {fontSize: 6, textAlign: "center"}]}>
                                Esta planilla debe ser impresa en Papel Bond Blanco tamaño Carta | Para autenticar este recibo vaya al enlace: https://iudlm.com/recibo?code={(datos.token).substring(0,10)}. También puedes escanear el código qr de la derecha.
                            </Text>
                            <Text style={[styles.linea2]}></Text>
                            <Text style={[styles.encabezado]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                        <View style={[styles.col10]}>
                            {this.qrC(qrCode, styles)}
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }

    render() {
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section2}>
                <Document title="Recibo de Pago">
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido("ORIGINAL - INSTITUTO")}
                        </View>
                        <View style={[styles.font9, {paddingTop: 20, paddingBottom: 20}]}>
                            <Text>{'-'.repeat(192)}</Text>
                        </View>
                        <View>
                            {this.contenido("COPIA - ESTUDIANTE")}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default ReciboDePagoUrl;


// WEBPACK FOOTER //
// ./src/components/Reportes/ReciboDePagoUrl.jsx